import { Icon, type IconName } from './Icon';

export type EmptyProps = {
  icon?: IconName;
  title?: string;
  subtitle?: string;
};

export function Empty({ icon = 'search', title, subtitle }: EmptyProps) {
  return (
    <div className="empty">
      <div className="empty-icon">
        <Icon name={icon} size={20} />
      </div>
      {title && <div className="empty-title">{title}</div>}
      {subtitle && <div className="empty-subtitle">{subtitle}</div>}
    </div>
  );
}
